module.exports = __webpack_public_path__ + "static/img/67.4c1bce0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/67.png
// module id = CM6Z
// module chunks = 1